import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../setup";

// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Users"],
  endpoints: (builder) => ({
    getUserList: builder.query({
      query: (organizationSubDomain) => {
        return {
          url: `/user/list`,
          method: "GET",
          params: { subdomain: organizationSubDomain },
        };
      },
      providesTags: (result) => {
        return result
          ? [
              ...result.map(({ id }) => ({ type: "Users", id })),
              { type: "Users", id: "LIST" },
            ]
          : [{ type: "Users", id: "LIST" }];
      },
    }),
    createUser: builder.mutation({
      query: ({ subdomain, payload }) => {
        return {
          url: `/user/create`,
          method: "POST",
          body: { ...payload },
          params: { subdomain },
        };
      },
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    updateUser: builder.mutation({
      query: ({ subdomain, id, payload }) => {
        return {
          url: `/user/${id}`,
          method: "PATCH",
          body: payload,
          params: { subdomain },
        };
      },
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    updateUserPassword: builder.mutation({
      query: ({subdomain, payload}) => {
        return {
          url: `/user/update-password`,
          method: "POST",
          body: payload,
          params: { subdomain }
        }
      },
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    deleteUser: builder.mutation({
      query: ({ subdomain, id }) => {
        return {
          url: `/user/${id}`,
          method: "DELETE",
          params: { subdomain },
        };
      },
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    getMe: builder.query({
      query: () => {
        return {
          url: `auth/user`,
          method: "GET",
        };
      },
      providesTags: [{ type: "Profile", id: "Profile" }],
    }),
  }),
});

export const {
  useLazyGetUserListQuery,
  useGetUserListQuery,
  useUpdateUserMutation,
  useUpdateUserPasswordMutation,
  useCreateUserMutation,
  useDeleteUserMutation,
  useLazyGetMeQuery,
  useGetMeQuery,
} = userApi;
